
<div>
    <Modal v-if="showModal" ref="modal-branches" id="modal-branches" centered :scrollable="postalCodeSend"
           :size="'md'" @close="hide()">
        <div slot="header" class="px-3 pt-3 select-branch-modal-header">
            <h2 class="select-branch-modal-title">Selecciona tu sucursal más cercana para recibir noticias y promociones</h2>
            <div v-show="postalCodeSend && locations.length > 0" class="select-branch-modal-postal-code-container">
                <label class="select-branch-modal-postal-code-label">Buscar otro código postal</label>
                <div class="select-branch-modal-postal-code-input">
                    <div id="geocoderHeader"></div>
                </div>
            </div>
            <div v-show="postalCodeSend" class="select-branch-modal-branches-header-info">
                <p>Código postal: <strong style="color: #2c5697">{{ postalCode }}</strong></p>
                <p>{{ locations.length }} resultados</p>
            </div>
        </div>
        <div slot="body">
            <div v-show="!postalCodeSend" class="select-branch-modal-container">
                <button class="btn btn-primary btn-orange mb-3" @click="geoFindMe()">
                    <span>Activar mi geolocalización</span>
                </button>
                <span class="select-branch-modal-title" style="margin-bottom: 4px">o</span>
                <div class="select-branch-modal-postal-code-container">
                    <label class="select-branch-modal-postal-code-label">Ingresa tu código postal y selecciona un
                        resultado</label>
                    <div class="select-branch-modal-postal-code-input">
                        <div id="geocoder"></div>
                    </div>
                </div>
            </div>
            <div v-show="postalCodeSend" class="select-branch-modal-branches-container">
                <div v-show="!locationsLoading && locations.length === 0" class="select-branch-modal-branches-retry">
                    <p>No hay sucursales cerca de ti</p>
                    <button class="btn btn-primary btn-orange m-0" @click="retrySearch()">
                        <span>Intenta de nuevo</span>
                    </button>
                </div>
                <div v-if="locationsLoading" class="spinner-border"
                     style="color: #2c5697; width: 3rem; height: 3rem;"></div>
                <div v-else class="select-branch-modal-branches-list">
                    <div v-for="location in locations" class="select-branch-modal-branch-container">
                        <div class="select-branch-modal-branch-header">
                            <p><strong>{{ location.title }}</strong></p>
                            <p><strong>({{ location.distance.toFixed(2) }} Km)</strong></p>
                        </div>
                        <p>{{ location.store }}</p>
                        <p>{{ location.address }}</p>
                        <p>{{ location.store_schedule[0].days }} de
                            <strong>{{ formatTime(location.store_schedule[0].open_time) }} -
                                {{ formatTime(location.store_schedule[0].close_time) }}</strong></p>
                        <div class="select-branch-modal-branch-button">
                            <button class="btn btn-primary btn-orange m-2" @click="$emit('select-branch', location);hide();">
                                Seleccionar esta sucursal
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Modal>
</div>
